import { Box, Slider, styled } from "@mui/material";

export const StyledFileEditor = styled(Box)(({ theme }) => ({
  position: "fixed",
  background: "rgba(0, 0, 0, 0.7)",
  left: "0",
  top: "0",
  width: "100%",
  height: "100%",
  zIndex: "60",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  gap: "1rem",
  paddingInline: "2rem",
  paddingTop: "2rem",
  ".contentWrapper": {
    display: "flex",
    width: "100%",
    height: "100%",
    gap: "2rem",
    justifyContent: "center",
    alignItems :"center",
    overflow: "hidden",
    ".documentWrapper": {
      width: "90%",
      overflowY: "scroll",
      maxHeight: "85vh",
      overflowX: "hidden",
    },
    ".viewport": {
      touchAction: "none",
      position: "relative",
      cursor: "pencil",
      overscrollBehavior: "contain",
    },
    ".saveWindow": {
        position:"absolute",
        background: theme.color.background,
        paddingInline: "5rem",
        borderRadius: "5px",
        textAlign: "center",
        color: theme.color.dark,
        alignItems: "center",
        justifyContent: "center",
        display: "flex",
        flexDirection: "column",
        paddingBlock: "2rem",
        gap: "1rem",
        h2: {
          display: "inline-block",
        },
        ".buttonWrapper": {
          display: "flex",
          width: "100%",
          justifyContent: "space-between"
        },
        ".MuiOutlinedInput-root": {
          width: "100%",
          "& .MuiInputBase-input": {
            fontSize: "2rem",
            padding: "4px 8px",
            width: "auto",
            textAlign: "center",
          },
          "& .MuiOutlinedInput-root": {
            padding: 0,
            height: "auto",
            width: "auto",
          },
        },
      },
    ".toolbar": {
      position: "absolute",
      background: theme.color.background,
      borderRadius: "10px",
      display: "flex",
      alignItems: "center",
      top: "0rem",
      marginTop: ".5rem",
      marginInline:"auto",
      flexDirection: "column",
      ".slider": {
        width: "100%",
        display: "none",
        alignItems: "center",
        gap: "2rem",
        paddingInline: "2rem",
        boxSizing: "border-box",
      },
      ".colorpicker": {
        display: "none"
      },
      ".toggled": {
        display: "flex",
      },
    },
    ".buttonGroup": {
      display: "flex",
      boxSizing: "border-box",
      paddingBlock: "1rem",
      borderRadius: "10px",
      height: "min-content",
      flexWrap: "wrap",
      gap: ".5rem",
      padding: ".5rem",
      width: "100%",
      ".button": {
        width: "3rem",
        height: "3rem",
        padding: "0",
        margin: "0",
        borderRadius: "10px",
        border: `3px solid ${theme.color.main}`,
        background: theme.color.background,
        color: theme.color.main,
        boxSizing: "border-box",
        minWidth: "0",
      },
      ".MuiToggleButton-root.Mui-selected": {
        background: theme.color.dark,
        color: theme.color.background,
      },
    },
  },

  ".closeBtn": {
    color: theme.color.background,
    position: "absolute",
    right: "3rem",
    top: "3rem",
    cursor: "pointer",
  },

  ".panZoomLayer": {
    transformOrigin: "0 0",
    willChange: "transform",
  },
  ".pageWrapper": {
    position: "relative",
  },
  ".document": {
    display: "block",
    overflowY: "auto",
    margin: "auto",
    width: "70vw",
    height: "90vh",
  },
  ".drawCanvas": {
    position: "absolute",
    top: "0",
    toolbartools: "0",
    height: "100%",
    width: "100%",
  },
  ".previewCanvas": {
    position: "absolute",
    top: "0",
    toolbartools: "0",
    height: "100%",
    width: "100%",
    inset: 0,
    pointerEvents: "none",
  },
  ".drawCanvas, .previewCanvas": {},
  ".pdfDocument": {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    height: "100%",
  },
  ".fileRemoveIconWrapper": {
    position: "absolute",
    zIndex: "99",
    top: "1rem",
    right: "1rem",
    display: "flex",
    gap: "1rem",
    flexDirection: "column-reverse",
  },
}));

export const StyledSlider = styled(Slider)(({ theme }) => ({
  height: "30%",
  "& .MuiSlider-track": {
    border: "none",
  },
  "& .MuiSlider-thumb": {
    height: 24,
    width: 24,
    border: "2px solid currentColor",
    "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
      boxShadow: "inherit",
    },
    "&::before": {
      display: "none",
    },
  },
  "& .MuiSlider-valueLabel": {
    lineHeight: 1.2,
    fontSize: 12,
    background: "unset",
    padding: 0,
    width: 32,
    height: 32,
    borderRadius: "50% 50% 50% 0",
    transformOrigin: "bottom toolbartools",
    transform: "translate(50%, -100%) rotate(-45deg) scale(0)",
    "&::before": { display: "none" },
    "&.MuiSlider-valueLabelOpen": {
      transform: "translate(50%, -100%) rotate(-45deg) scale(1)",
    },
    "& > *": {
      transform: "rotate(45deg)",
    },
  },
}));
